var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"bg"},[_c('div',{staticClass:"mt-5"},[_c('section',{staticClass:"content"},[_c('CmpEmptyData',{staticClass:"mt-10",attrs:{"btnShow":false,"txtCaptionShow":false}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }